/**
 * Security level display utilities
 * Shared between App.js (Funded By table) and CoinInfo.js (contract addresses)
 */

/**
 * Get display info for a security level
 * @param {number|null} level - Security level (1-5, 0 or null for unknown)
 * @returns {Object} { text, bg, textColor }
 */
export const getSecurityLevelInfo = (level) => {
  if (level == null || level === 0) {
    return { text: 'N/A', bg: '', textColor: 'text-gray-600' };
  }
  switch (level) {
    case 1:
      return { text: 'Very Low', bg: 'bg-red-300', textColor: 'text-red-900' };
    case 2:
      return { text: 'Low', bg: 'bg-red-200', textColor: 'text-red-800' };
    case 3:
      return { text: 'Medium', bg: 'bg-orange-200', textColor: 'text-orange-800' };
    case 4:
      return { text: 'Good', bg: 'bg-yellow-200', textColor: 'text-yellow-800' };
    case 5:
      return { text: 'Excellent', bg: 'bg-green-200', textColor: 'text-green-800' };
    default:
      return { text: 'N/A', bg: '', textColor: 'text-gray-600' };
  }
};
